import type { SVGProps } from 'react';
const SvgFileDocumentInfoQuickReferenceStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'File Document Info Quick Reference Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.982 1.982v14.536c0 .73.592 1.321 1.322 1.321h11.892c.73 0 1.322-.591 1.322-1.321V5.286L11.893.66h-8.59c-.73 0-1.32.591-1.32 1.321Z" />
      <path strokeLinecap="round" d="M7.268 13.214h3.964M9.25 13.214V8.59H7.929" />
      <g strokeLinecap="round">
        <path d="M9.25 5.616a.33.33 0 0 1 0-.66M9.25 5.616a.33.33 0 0 0 0-.66" />
      </g>
    </g>
  </svg>
);
export default SvgFileDocumentInfoQuickReferenceStreamlineCore;
